import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { getFacilityByUserId, getAllFacilities, leaveFacility, connectToFacility } from './actions';
import { FacilityResponseDto, ValueOf } from 'types/types';
import { DataStatus } from 'types/enums';

type State = {
  status: ValueOf<typeof DataStatus>;
  accountFacilities: null | FacilityResponseDto[];
  facilities: FacilityResponseDto[];
};

const initialState: State = {
  accountFacilities: null,
  status: DataStatus.IDLE,
  facilities: [],
};

const { reducer, actions } = createSlice({
  initialState,
  name: 'facility',
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getAllFacilities.fulfilled, (state, { payload }) => {
      state.facilities = payload;
      state.status = DataStatus.SUCCEEDED;
    });
    builder.addCase(getAllFacilities.rejected, (state) => {
      state.facilities = [];
    });
    builder.addCase(getFacilityByUserId.fulfilled, (state, { payload }) => {
      state.status = DataStatus.SUCCEEDED;
      state.accountFacilities = payload;
    });
    builder.addCase(getFacilityByUserId.rejected, (state) => {
      state.accountFacilities = null;
    });
    builder.addMatcher(isAnyOf(leaveFacility.fulfilled, connectToFacility.fulfilled), (state) => {
      state.status = DataStatus.SUCCEEDED;
    });
    builder.addMatcher(
      isAnyOf(getFacilityByUserId.pending, getAllFacilities.pending, leaveFacility.pending, connectToFacility.pending),
      (state) => {
        state.status = DataStatus.LOADING;
      },
    );
    builder.addMatcher(
      isAnyOf(
        getFacilityByUserId.rejected,
        getAllFacilities.rejected,
        leaveFacility.rejected,
        connectToFacility.rejected,
      ),
      (state) => {
        state.status = DataStatus.FAILED;
      },
    );
  },
});

export { actions, reducer };
